import script from "./AgentRoles.vue?vue&type=script&lang=ts&setup=true"
export * from "./AgentRoles.vue?vue&type=script&lang=ts&setup=true"

import "./AgentRoles.vue?vue&type=style&index=0&id=4d34ba44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d34ba44"]])

export default __exports__